import React from "react";
import './Navigation.scss';
import lang from '../../i18/lang';
import Lego_color from "../../assets/images/Logo_color.png";

class Navigation extends React.Component {

    scrollToRef = (ref) => window.scrollTo({behavior: 'smooth', top: ref.current.offsetTop});

    render() {
        return (
            <div>
                <div className="navigation-wrapper">
                    <div className="nav-items">
                        <div className="nav-item" onClick={() => this.scrollToRef(this.props.ref_about)}>
                            <p>{lang.srb.o_name}</p>
                        </div>
                        <div className="nav-item" onClick={() => this.scrollToRef(this.props.ref_reference)}>
                            <p>{lang.srb.reference}</p>
                        </div>
                        <div className="nav-item-logo">
                            <img src={Lego_color}/>
                        </div>
                        <div className="nav-item" onClick={() => this.scrollToRef(this.props.ref_services)}>
                            <p>{lang.srb.usluge}</p>
                        </div>
                        <div className="nav-item" onClick={() => this.scrollToRef(this.props.ref_gallery)}>
                            <p>{lang.srb.galerija}</p>
                        </div>
                    </div>
                    <div className="navigation-contact">
                        <div><a href="mailto:bamigraonice@gmail.com"><img width={15} src="/icons/email.png"/><span>bamigraonice@gmail.com</span></a></div>
                        <div><a href="tel:+38162440313"><img width={15} src="/icons/phone.png"/><span>062-44-0313</span></a></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Navigation;